// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__ZQZQq","all":"LandingPage_all__R3+ms","text-shadow":"LandingPage_text-shadow__2PzS8","buttonLanding":"LandingPage_buttonLanding__G3sAd"};